import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { KeyboardDatePicker, KeyboardTimePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import Icon from '../../../core/Icon';
import withMomentTz from '../../../core/EcrionProvider/withMomentTz';
import moment from 'moment';
var dateDefaults = {
  rightArrowIcon: React.createElement(Icon, {
    type: "right"
  }),
  leftArrowIcon: React.createElement(Icon, {
    type: "left"
  })
};

var dateTimeDefaults = _objectSpread({}, dateDefaults, {
  showTabs: false,
  timeIcon: React.createElement(Icon, {
    type: "time"
  }),
  dateRangeIcon: React.createElement(Icon, {
    type: "date"
  })
});
/**
 * @param {string} time in `hh:mm:ss A` format
 * @returns {string} ISO date time forced to 1900
 */


var createDateTimeFromTime = function createDateTimeFromTime(time) {
  var datetime = moment.utc("1900-01-01 ".concat(time), 'YYYY-MM-DD hh:mm:ss A');
  var str = datetime.toISOString();
  return str;
};
/**
 * @param {import('../types').FormInputDateTimeProps} props
 */


function DateTime(_ref) {
  var type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["type"]);

  var variant = rest.variant,
      pickerVariant = rest.pickerVariant,
      formatType = rest.formatType,
      helperText = rest.helperText,
      error = rest.error,
      props = _objectWithoutProperties(rest, ["variant", "pickerVariant", "formatType", "helperText", "error"]);
  /**@type {import('@material-ui/pickers/typings/BasePicker').BasePickerProps} */


  var pickerProps = props;
  pickerProps.inputVariant = variant;
  pickerProps.variant = pickerVariant;
  pickerProps.format = formatType;

  var _React$useState = React.useState(undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      inputValue = _React$useState2[0],
      setInputValue = _React$useState2[1]; //helpertext and error if they are passed as undefined/false to keyboard component, invalidDateFormat error doesn't work.


  if (helperText) {
    pickerProps.helperText = helperText;
  }

  if (error) {
    pickerProps.error = error;
  }

  pickerProps.rifmFormatter = function (v) {
    return v;
  };

  pickerProps.refuse = /[\n]+/g;
  pickerProps.inputValue = inputValue;

  if (type === 'time' && typeof pickerProps.value === 'string') {
    //adjust value to be ISO
    // this allows the user to pass a "03:00:00 AM" as value
    pickerProps.value = createDateTimeFromTime(pickerProps.value);
    pickerProps.value = moment.tz(pickerProps.value, 'UTC');
    pickerProps.value.keepTime = true;
  }

  var oldOnFocus = pickerProps.onFocus;

  pickerProps.onFocus = function (event) {
    setInputValue(event.target.value); //event.currentTarget.focus();

    if (oldOnFocus) oldOnFocus(event);
  };
  /**@type {import('./types').FormInputDateTimeOnChange} */


  var userOnChange = props.onChange;

  var triggerOnChange = function triggerOnChange(momentDate) {
    var utcISO = momentDate && momentDate.toISOString();
    userOnChange(momentDate, utcISO);
  };

  pickerProps.onChange = function (momentDate, value) {
    if (typeof inputValue !== 'undefined') {
      setInputValue(value);
    } else {
      if (type === 'time') {
        var pickedTime = momentDate.format('hh:mm:ss A');
        var timeValue = createDateTimeFromTime(pickedTime); //always use UTC for times to avoid DST skips

        momentDate = moment.tz(timeValue, 'UTC');
        momentDate.keepTime = true;
      }

      triggerOnChange(momentDate);
    }
  };

  var oldOnBlur = pickerProps.onBlur;

  pickerProps.onBlur = function (event) {
    setInputValue(undefined);
    var targetValue = event.target.value;
    var tzone = moment.timezone;

    if (type === 'time') {
      //always use UTC for times to avoid DST skips
      tzone = 'UTC';
    }

    var momentDate;

    if (type === 'time') {
      var timeValue = targetValue ? createDateTimeFromTime(targetValue) : null;
      momentDate = moment.tz(timeValue, tzone);
    } else {
      momentDate = moment.tz(targetValue, "LLL", tzone);
    }

    if (!momentDate.isValid()) {
      momentDate = moment.tz(props.value, tzone);

      if (!momentDate.isValid()) {
        momentDate = null;
      }
    }

    if (momentDate && type === 'time') {
      momentDate.keepTime = true;
    }

    triggerOnChange(momentDate);
    if (oldOnBlur) oldOnBlur(event);
  };

  if (type === 'datetime') return React.createElement(KeyboardDateTimePicker, Object.assign({}, dateTimeDefaults, pickerProps));
  if (type === 'date') return React.createElement(KeyboardDatePicker, Object.assign({}, dateDefaults, pickerProps));
  if (type === 'time') return React.createElement(KeyboardTimePicker, pickerProps);
  return null;
}

DateTime.defaultProps = {
  type: 'datetime'
};
var DateTimeMomentTz = withMomentTz(DateTime);
export default DateTimeMomentTz;